import { render, staticRenderFns } from "./indexFooter.vue?vue&type=template&id=9f3a468c&scoped=true"
import script from "./indexFooter.vue?vue&type=script&lang=js"
export * from "./indexFooter.vue?vue&type=script&lang=js"
import style0 from "./indexFooter.vue?vue&type=style&index=0&id=9f3a468c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3a468c",
  null
  
)

export default component.exports